app.controller('BrowseOptionProductController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.product = null;
    $scope.option_product_model = null;

    let currentModelIndex = 0;
    $scope.combined_input_values = {};

    $scope.local_option_term_models = {};
    $scope.view_model = {
        have_any_collapsible: false,
        show_collapsible: false
    }

    $scope.applyOptionProduct = function (applyProduct) {
        const optionProductModel = applyProduct && !applyProduct.disabled && applyProduct.getOptionProductModel ? applyProduct.getOptionProductModel() : null;
        if (!optionProductModel) {
            return false;
        }
        const didChange = optionProductModel !== $scope.option_product_model;
        $scope.product = applyProduct;
        $scope.option_product_model = optionProductModel;

        applyFindChoice();
        applyModelState();
        applyComplexOption();

        if (didChange || currentModelIndex < 0) {
            setCurrentModelIndex(0, true);
        }
        if (currentModelIndex < 0) {
            return false;
        }
        applyLocalOptionTermModels()

        checkForErrors();

        return true;
    }

    $scope.selectOptionTermChoice = function (optionID, optionTermID) {
        const optionTermModel = $scope.option_product_model.term_models[optionID];

        if (!optionTermModel) {
            return;
        }

        let currentValue = $scope.product.option_term_ids[optionID];
        currentValue = currentValue !== undefined ? currentValue : null;

        if (currentValue === optionTermID && !optionTermModel.required) {
            currentValue = null;
        } else {
            currentValue = optionTermID;
        }
        $scope.product.option_term_ids[optionID] = currentValue;

        $scope.onOptionTermChange();
    }

    $scope.onOptionTermChange = function (optionID) {
        const currentValue = $scope.product.option_term_ids[optionID];

        applyComplexOption();

        if (currentValue) {
            checkForNext();
        }
        if ($scope.onOptionTermChoiceSelected) {
            $scope.onOptionTermChoiceSelected();
        }
    }

    function applyComplexOption() {
        const optionTermModelList = $scope.option_product_model.term_model_list;
        for (let i = 0; i < optionTermModelList.length; i++) {
            const optionTermModel = optionTermModelList[i];

            if (optionTermModel.is_complex_option_term) {
                const complexChoice = optionTermModel.currentComplexOptionTermChoice($scope.product);
                const currentValue = $scope.product.option_term_ids[optionTermModel.option_id];
                if (currentValue && !complexChoice && (!optionTermModel.parent_complex_option_term_model || optionTermModel.getParentComplexOptionTermChoiceID($scope.product))) {
                    $scope.product.option_term_ids[optionTermModel.option_id] = null;
                }
            }
        }
    }

    $scope.selectedOptionTermChoice = function (optionID) {
        const optionTermModel = $scope.option_product_model.term_models[optionID];
        const optionTermID = $scope.product.option_term_ids[optionID];
        return optionTermModel && optionTermID && optionTermModel.choices[optionTermID] ? optionTermModel.choices[optionTermID] : null;
    }

    $scope.applyCombinedInput = function () {
        const optionTermModelList = $scope.option_product_model.term_model_list;
        for (let i = 0; i < optionTermModelList.length; i++) {
            const model = optionTermModelList[i];
            $scope.combined_input_values[model.option_id] = [];
            for (let j = 0; j < model.input_section_list.length; j++) {
                const section = model.input_section_list[j];
                $scope.combined_input_values[model.option_id][j] = null;
                if (section.required) {
                    section.value = null;
                    for (let k = 0; k < section.input_list.length; k++) {
                        const input = section.input_list[k];
                        const inputID = input.id;
                        const inputValue = $scope.product.option_term_values && $scope.product.option_term_values[model.option_id] ? $scope.product.option_term_values[model.option_id][inputID] : null;
                        if (inputValue) {
                            section.value = 1;
                            $scope.combined_input_values[model.option_id][j] = 1;
                            break;
                        }
                    }
                }
            }
        }
    }

    $scope.anyErrors = function (optionTermModel) {
        if (!$scope.hasAnyErrors) {
            return false;
        }

        if ($scope.hasAnyErrors(optionTermModel.input_name)) {
            return true;
        }

        for (let i = 0; i < optionTermModel.input_section_list.length; i++) {
            const section = optionTermModel.input_section_list[i];
            if ($scope.hasAnyErrors(section.input_name)) {
                return true;
            }
            for (let j = 0; j < section.input_list.length; j++) {
                const input = section.input_list[j];
                if (input.input_name && $scope.hasAnyErrors(input.input_name)) {
                    return true;
                }
            }
        }
        return false;
    }

    function checkForNext() {
        const errorModelIndex = firstErrorModelIndex();
        if (errorModelIndex >= 0) {
            setCurrentModelIndex(errorModelIndex, false)
        } else {
            if (currentModelIndex < $scope.option_product_model.term_model_list.length - 1) {
                setCurrentModelIndex(currentModelIndex + 1, true)
            }
        }
    }

    function checkForErrors() {

        const errorModelIndex = firstErrorModelIndex();
        if (errorModelIndex >= 0) {
            setCurrentModelIndex(errorModelIndex, false)
        }
    }

    function firstErrorModelIndex() {
        const optionTermModelList = $scope.option_product_model.term_model_list;
        for (let i = 0; i < optionTermModelList.length; i++) {
            if ($scope.anyErrors(optionTermModelList[i])) {
                return i;
            }
        }
        return -1;
    }

    function setCurrentModelIndex(modelIndex, orBest) {
        currentModelIndex = -1;
        let previousIndex = -1;
        let currentIndex = -1;
        let nextIndex = -1;
        const optionTermModelList = $scope.option_product_model.term_model_list;
        for (let i = 0; i < optionTermModelList.length; i++) {
            const checkModel = optionTermModelList[i];
            if (checkModel.hidden) {
                continue;
            }
            if (i === modelIndex) {
                currentIndex = i;
                break;
            }
            if (i > modelIndex) {
                nextIndex = i;
                break;
            }
            previousIndex = i;
        }
        if (currentIndex >= 0) {
            currentModelIndex = currentIndex;
            return;
        }
        if (orBest) {
            if (nextIndex >= 0) {
                currentModelIndex = nextIndex;
            }
            if (previousIndex >= 0) {
                currentModelIndex = previousIndex;
            }
        }
    }

    function applyFindChoice() {
        let choiceIdDidChange = false;

        if ($scope.product.find_option_term_choice) {
            for (let optionID in $scope.product.find_option_term_choice) {
                const optionTermModel = $scope.option_product_model.term_models[optionID];
                if (optionTermModel) {
                    $scope.product.option_term_ids[optionTermModel.option_id] = $scope.product.find_option_term_choice[optionID];
                    choiceIdDidChange = true;
                }
            }
            delete $scope.product.find_option_term_choice;
        }
        return choiceIdDidChange;
    }

    function applyModelState() {
        let choiceIdDidChange = false;
        const optionTermModelList = $scope.option_product_model.term_model_list;
        for (let i = 0; i < optionTermModelList.length; i++) {
            const model = optionTermModelList[i];
            choiceIdDidChange = model.applyCurrentState($scope.product);
        }
        return choiceIdDidChange;
    }

    function applyLocalOptionTermModels() {
        $scope.view_model.have_any_collapsible = false
        for (let i = 0; i < $scope.option_product_model.term_model_list.length; i++) {
            const optionTermModel = $scope.option_product_model.term_model_list[i];
            if (optionTermModel.hidden) {
                continue;
            }
            const optionID = optionTermModel.option_id;
            if (!$scope.local_option_term_models[optionID]) {
                let optionTermID = $scope.product.option_term_ids[optionID];
                optionTermID = optionTermID && optionTermID !== "NONE" ? optionTermID : null;
                let canCollapse = false;
                if (!optionTermModel.always_visible) {
                    if ($scope.collapse_preselected && optionTermID) {
                        canCollapse = true;
                    }
                    if ($scope.collapse_non_required && !optionTermModel.required) {
                        canCollapse = true;
                    }
                }
                $scope.local_option_term_models[optionID] = {
                    option_id: optionTermModel.option_id,
                    initial_option_term_id: optionTermID,
                    can_collapse: canCollapse
                }
            }
            if ($scope.local_option_term_models[optionID].can_collapse) {
                $scope.view_model.have_any_collapsible = true
            }
        }
    }

}]);